/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SearchDealsQueryResponse,
  SearchDealsQueryParams,
} from '../types/SearchDeals'

function getSearchDealsUrl() {
  const res = { method: 'GET', url: `/api/v1/common/search/deals/` as const }
  return res
}

/**
 * @description Handle GET request for search.
 * This is the main entry point that orchestrates the search process.
 * @summary Search the tenant's deals
 * {@link /api/v1/common/search/deals/}
 */
export async function searchDeals(
  params?: SearchDealsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SearchDealsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getSearchDealsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
